import { Toggle } from '@thoughtspot/radiant-react/widgets/toggle';
import React, { useCallback } from 'react';
import styles from './toggle-input.module.scss';
export const ToggleInput = ({ title, checked, onChange, name, disabled, }) => {
    const handleChange = useCallback((e) => {
        if (!disabled) {
            onChange(e);
        }
    }, [onChange, disabled]);
    return (React.createElement(Toggle, { label: title, hideLabel: true, checked: checked, onChange: handleChange, name: name, disabled: disabled, className: styles.toggle, "data-testid": `feature-toggle-${name}` }));
};
//# sourceMappingURL=toggle-input.js.map